import {
  AMONDZ_PRODUCT_MANAGEMENT_TYPE_SELECT_LIST,
  DEFAULT_DIRECT_DELIVERY_TIME_LIMIT,
  DEFAULT_ORDER_MADE_DATE,
  DEFAULT_PRO_PROPERTY,
  DEFAULT_PRODUCT_PROPERTY,
  MINIMUM_PRICE_9900_WON_CATEGORY_PRICE,
  PRODUCT_MANAGEMENT_TYPE,
  PRODUCT_MAXIMUM_PRICE,
  PRODUCT_OPTION_STATUS,
} from '../../../constants/service/app/productConstants';
import { PAY_METHOD_TYPE } from '../../../constants/service/app/orderConstants';
import { setProductVersionInfo } from '../../../lib/utils';
import { LIST_PAGINATION_MODEL } from '../app/models';

/**
 *  상품 리스트 검색 박스 모델
 */
export const PRODUCT_LIST_SEARCH_DATA_MODEL = {
  /**
   *  판매가 상세 검색 토글
   */
  priceDetailToggle: false,

  /**
   *  할인 상세 검색 토글
   */
  discountDetailToggle: false,

  /**
   *  실판매가
   */
  salesPrice: {
    checkList: [],
    startPrice: [],
    endPrice: [],
  },

  /**
   *  판매가
   */
  originPrice: {
    priceIndex: null,
    startPrice: 0,
    endPrice: PRODUCT_MAXIMUM_PRICE,
  },

  /**
   *  할인된 판매가
   */
  discountedPrice: {
    priceIndex: null,
    startPrice: 0,
    endPrice: PRODUCT_MAXIMUM_PRICE,
  },

  /**
   *  할인율
   */
  discountRate: {
    checkList: [],
    startRate: [],
    endRate: [],
  },

  /**
   *  할인가
   */
  discountPrice: {
    priceIndex: null,
    startPrice: 0,
    endPrice: PRODUCT_MAXIMUM_PRICE,
  },

  /**
   *  할인설정
   */
  discountType: {
    discountIndex: null,
    value: null,
  },

  /**
   *  상품 카테고리
   */
  productCategory: {
    list: [],
  },

  /**
   *  상품 태그
   */
  productTag: {
    /**
     *  태그 그룹
     */
    tagGroupList: [],
    /**
     *  태그
     */
    tagList: [],
  },
};

export const INITIAL_PRODUCT_LIST_SEARCH_DATA = {
  /**
   *  검색 시 UI 에서 사용되던 데이터를 제거하고 서버에 요청한다.
   */
  searchData: PRODUCT_LIST_SEARCH_DATA_MODEL,
  searchOption: {
    /**
     *  실판매가
     */
    salesPrice: {
      startPrice: PRODUCT_LIST_SEARCH_DATA_MODEL.salesPrice.startPrice,
      endPrice: PRODUCT_LIST_SEARCH_DATA_MODEL.salesPrice.endPrice,
    },
    /**
     *  판매가
     */
    originPrice: {
      startPrice: PRODUCT_LIST_SEARCH_DATA_MODEL.originPrice.startPrice,
      endPrice: PRODUCT_LIST_SEARCH_DATA_MODEL.originPrice.endPrice,
    },
    /**
     *  할인된 판매가
     */
    discountedPrice: {
      startPrice: PRODUCT_LIST_SEARCH_DATA_MODEL.discountedPrice.startPrice,
      endPrice: PRODUCT_LIST_SEARCH_DATA_MODEL.discountedPrice.endPrice,
    },
    /**
     *  할인율
     */
    discountRate: {
      startRate: PRODUCT_LIST_SEARCH_DATA_MODEL.discountRate.startRate,
      endRate: PRODUCT_LIST_SEARCH_DATA_MODEL.discountRate.endRate,
    },
    /**
     *  할인가
     */
    discountPrice: {
      startPrice: PRODUCT_LIST_SEARCH_DATA_MODEL.discountPrice.startPrice,
      endPrice: PRODUCT_LIST_SEARCH_DATA_MODEL.discountPrice.endPrice,
    },
    /**
     *  할인설정 (원, %)
     */
    discountType: PRODUCT_LIST_SEARCH_DATA_MODEL.discountType.value,
    /**
     *  상품 카테고리
     */
    productCategory: PRODUCT_LIST_SEARCH_DATA_MODEL.productCategory,
    /**
     *  상품 태그
     */
    productTag: PRODUCT_LIST_SEARCH_DATA_MODEL.productTag,
  },
  pagination: LIST_PAGINATION_MODEL,
};

/**
 *  상품 리스트 검색 박스 옵션 모델
 */
export const PRODUCT_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  실판매가
   */
  salesPrice: {
    startPrice: [],
    endPrice: [],
  },

  /**
   *  판매가
   */
  originPrice: {
    startPrice: 0,
    endPrice: PRODUCT_MAXIMUM_PRICE,
  },

  /**
   *  할인된 판매가
   */
  discountedPrice: {
    startPrice: 0,
    endPrice: PRODUCT_MAXIMUM_PRICE,
  },

  /**
   *  할인율
   */
  discountRate: {
    startRate: [],
    endRate: [],
  },

  /**
   *  할인가
   */
  discountPrice: {
    startPrice: 0,
    endPrice: PRODUCT_MAXIMUM_PRICE,
  },

  /**
   *  할인설정
   */
  discountType: null,
};

/**
 *  상품 리스트 필터 옵션 모델
 */
export const PRODUCT_LIST_FILTER_OPTION_MODEL = {
  /**
   *  상품 ID
   */
  productId: null,
  /**
   *  상품 명
   */
  productName: null,
  /**
   *  상품 1차 카테고리
   */
  mainCategory: null,
  /**
   *  상품 2차 카테고리
   */
  subCategory: null,
  /**
   *  브랜드
   */
  brandName: null,
  /**
   *  브랜드 ID
   */
  storeId: null,
  /**
   *  상품 상태
   */
  status: null,
  /**
   *  판매가
   */
  originPrice: null,
  /**
   *  할인가
   */
  discountPrice: null,
  /**
   *  할인율
   */
  discountRate: null,
  /**
   *  실판매가
   */
  salesPrice: null,
  /**
   *  할인 시작일
   */
  discountStartDate: null,
  /**
   *  할인 종료일
   */
  discountEndDate: null,
  /**
   *  상품 금지 요청 상태
   */
  confirmProductStopRequestStatus: null,
  /**
   *  상품 등록일
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  최종 수정일
   */
  updateDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  브랜드 상태
   */
  storeStatus: null,
};

/**
 *  상품 리스트 정렬 옵션 모델
 */
export const PRODUCT_LIST_SORT_OPTION_MODEL = [
  {
    id: 'createDate',
    desc: true,
  },
];

/**
 *  상품 속성 검수 리스트 정렬 옵션 모델
 */
export const PRODUCT_PROPERTY_REQUEST_LIST_SORT_OPTION_MODEL = [
  {
    id: 'confirmProductPropertyCreateDate',
    desc: true,
  },
];

/**
 *  상품 상태 및 브랜드 정보
 */
export const PRODUCT_STATUS_AND_BRAND_INFO_MODEL = {
  /**
   *  상품 상태
   */
  status: null,
  /**
   *  상점 상태
   */
  storeStatus: null,
  /**
   *  승인 요청 여부
   */
  isRequest: false,
  /**
   *  승인 거절 여부
   */
  isReject: false,
  /**
   *  상품 삭제 여부
   */
  isDelete: false,
  /**
   *  상품 판매금지 재승인 요청 여부
   */
  isBanRequest: false,
  /**
   *  상품 상태 변경을 할 수 있는지 여부
   */
  enableStatus: true,
  /**
   *  버전 개수
   */
  versionCnt: null,
  /**
   *  스토어명
   */
  brandName: null,
  /**
   *  스토어 ID
   */
  storeId: null,
  /**
   *  스토어 전화번호
   */
  storePhone: null,
  /**
   *  스토어 대표 이미지
   */
  storeImg: null,
  /**
   *  제주 추가 배송비
   */
  deliveryChargeJeju: null,
  /**
   *  제주외 도서산간 추가 배송비
   */
  deliveryChargeEtc: null,
};

/**
 *  상품 상태
 */
export const PRODUCT_STATUS_MODEL = {
  /**
   *  상품 상태
   */
  status: null,
};

/**
 *  카테고리
 */
export const PRODUCT_CATEGORY_MODEL = {
  /**
   *  카테고리 ID list
   */
  categoryList: [],
  /**
   *  상품 최소값
   *  [카테고리에 따라서 상품의 최소값이 변경됨]
   */
  minimumPrice: MINIMUM_PRICE_9900_WON_CATEGORY_PRICE,
};

/**
 *  상품명, 가격, 할인정보
 */
export const PRODUCT_NAME_AND_PRICE_MODEL = {
  /**
   *  상품명
   */
  name: null,
  /**
   *  판매가
   */
  originPrice: 9900,
  /**
   *  실판매가
   */
  salesPrice: 9900,
  /**
   *  할인 여부
   */
  isDiscount: false,
  /**
   *  할인 타입 (0: 정액 할인, 1: 정률 할인)
   */
  discountType: 0,
  /**
   *  할인액
   */
  discountAmount: 10,
  /**
   *  할인율
   */
  discountRate: 10,
  /**
   *  할인 기간 설정 여부
   */
  isDiscountPeriod: false,
  /**
   *  할인 기간
   */
  discountPeriod: null,
};

/**
 *  재고/옵션
 */
export const PRODUCT_STOCK_AND_OPTION_MODEL = {
  /**
   *  스타일 코드
   */
  styleCode: null,
  /**
   *  상품 번호
   */
  number: null,
  /**
   *  옵션 여부
   */
  isOption: false,
  /**
   *  선택된 옵션
   */
  choiceOption: {
    /**
     *  선택된 옵션명의 ID
     */
    id: 1,
    /**
     *  선택된 옵션명
     */
    name: null,
    /**
     *  선택된 옵션값(CSV)
     */
    value: null,
  },
  optionKeyName: null,
  /**
   *  옵션목록으로 적용 버튼 동작 허용 여부
   */
  resetOptionAvailable: true,
  /**
   *  옵션 리스트
   */
  optionList: [],
  /**
   *  수수료 정보
   */
  feeInfo: {
    /**
     *  상품 관리 타입 SELECT LIST
     */
    productManagementTypeSelectList: AMONDZ_PRODUCT_MANAGEMENT_TYPE_SELECT_LIST,
    /**
     *  상품 관리 타입
     */
    productManagementType: PRODUCT_MANAGEMENT_TYPE.ENTER,
    /**
     *  선물 여부
     */
    isGift: true,
    /**
     *  재고 수량
     */
    stockCount: null,
    /**
     *  PG 수수료 여부
     */
    isPgFee: true,
    /**
     *  아몬즈수수료
     */
    amondzFeeRate: 14,
    /**
     *  마케팅수수료
     */
    marketingFeeRate: 10,
    /**
     *  풀필먼트수수료
     */
    fulfillmentFeeRate: 0,
  },
  /**
   *  브랜드 수수료 설정 정보 리스트
   */
  brandFeeInfoList: [],
};

/**
 * 상품 속성 모델
 */
export const PRODUCT_PROPERTY_MODEL = {
  mainMaterial: DEFAULT_PRODUCT_PROPERTY,
  otherMaterial: DEFAULT_PRODUCT_PROPERTY,
  acupunctureMaterial: DEFAULT_PRODUCT_PROPERTY,
  plateMaterial: DEFAULT_PRODUCT_PROPERTY,
  stoneMaterial: DEFAULT_PRODUCT_PROPERTY,
  mainColor: DEFAULT_PRODUCT_PROPERTY,
  decorativeFigure: DEFAULT_PRODUCT_PROPERTY,
  chainShape: DEFAULT_PRODUCT_PROPERTY,
};

/**
 *  상품 태그 모델
 */
export const PRODUCT_TAG_MODEL = {
  conceptTag: { list: [] },
  seasonSituationTag: { list: [] },
  etcTag: { list: [] },
};

/**
 *  상품 정보
 */
export const PRODUCT_INFO_MODEL = {
  /**
   *  상품 결제 타입
   */
  productPayMethodTypeId: 1,
  /**
   *  이전 상품 결제 타입
   */
  beforeProductPayMethodTypeId: 1,
  /**
   *  결제 가능 수단
   */
  productPayMethodList: [PAY_METHOD_TYPE.CARD, PAY_METHOD_TYPE.TRANS, PAY_METHOD_TYPE.VBANK],
  /**
   *  카드
   */
  card: 1,
  /**
   *  상품 속성
   */
  productPropertyList: {
    mainMaterial: DEFAULT_PRO_PROPERTY,
    otherMaterial: DEFAULT_PRO_PROPERTY,
    acupunctureMaterial: DEFAULT_PRO_PROPERTY,
    plateMaterial: DEFAULT_PRO_PROPERTY,
    stoneMaterial: DEFAULT_PRO_PROPERTY,
    mainColor: DEFAULT_PRO_PROPERTY,
    decorativeFigure: DEFAULT_PRO_PROPERTY,
    chainShape: DEFAULT_PRO_PROPERTY,
  },
  /**
   *  상품 태그
   */
  productTagInfo: PRODUCT_TAG_MODEL,
  /**
   *  사이즈
   */
  size: 'free',
  /**
   *  중량
   */
  weight: null,
  /**
   *  귀금속 장신구 여부
   */
  isExpensive: false,
  // /**
  //  *  소재/베이스 태그에서 "기타소재" 선택 여부
  //  */
  // isSelectMaterialEtcTag: false,
};

/**
 *  상품 이미지
 */
export const PRODUCT_IMG_MODEL = {
  /**
   *  메인 이미지
   */
  mainImg: [],
  /**
   *  추가 이미지
   */
  subImg: [],
  /**
   *  구매 시 유의 사항
   */
  notice: null,
};

/**
 *  상품 상세 설명
 */
export const PRODUCT_DESCRIPTION_IMG_MODEL = {
  /**
   *  상세 이미지
   */
  detailImg: [],
  /**
   *  주문 예시 메시지
   */
  orderExampleMessage: null,
};

/**
 *  배송 정보
 */
export const PRODUCT_DELIVERY_INFO_MODEL = {
  /**
   *  상품 배송 타입
   */
  deliveryType: null,
  /**
   *  주문 시 제작 제품 여부
   */
  isOrderMade: null,
  /**
   *  주문 시 제작 소요시간 (1 ~ 14)
   */
  orderMadeDate: DEFAULT_ORDER_MADE_DATE,
  /**
   *  바로 배송 기준 시간 (0 ~ 23)
   */
  directDeliveryTimeLimit: DEFAULT_DIRECT_DELIVERY_TIME_LIMIT,
  /**
   *  출고지 (배송지)
   */
  originAddress: {
    postCode: null,
    city: null,
    line1: null,
    line2: null,
    info: null,
  },
  /**
   *  반송지
   */
  returnAddress: {
    postCode: null,
    city: null,
    line1: null,
    line2: null,
    info: null,
  },
};

/**
 *  A/S 정보
 */
export const PRODUCT_AFTER_SERVICE_MODEL = {
  /**
   *  A/S 전화번호
   */
  asPhone: null,
  /**
   *  카카오톡 (플러스 친구)
   */
  kakaoAccount: null,
  /**
   *  A/S 안내
   */
  asInform: null,
  /**
   *  착용 시 주의 사항
   */
  caution: null,
  /**
   *  품질보증 기준
   */
  qualityAssurance: null,
  /**
   *  제조국
   */
  origin: null,
  /**
   *  제조사
   */
  manufacturer: null,
};

/**
 *  상품 버전 상세 모델
 */
export const PRODUCT_VERSION_DETAIL_MODEL = {
  /**
   *  상품 ID
   */
  productId: null,
  /**
   *  상품 로그 ID
   */
  productUpdateLogId: null,
  /**
   *  상품 상태 및 브랜드 정보
   */
  proStatus: PRODUCT_STATUS_MODEL,
  /**
   *  카테고리
   */
  proCategory: PRODUCT_CATEGORY_MODEL,
  /**
   *  상품명, 가격, 할인정보
   */
  proNameAndPrice: PRODUCT_NAME_AND_PRICE_MODEL,
  /**
   *  재고/옵션
   */
  proStockAndOption: PRODUCT_STOCK_AND_OPTION_MODEL,
  /**
   *  상품 공지사항
   */
  proNoticeProduct: {
    list: [],
  },
  /**
   *  상품 정보
   */
  proInfo: PRODUCT_INFO_MODEL,
  /**
   *  상품 이미지
   */
  proImg: PRODUCT_IMG_MODEL,
  /**
   *  상품 상세 설명
   */
  proDescriptionImg: PRODUCT_DESCRIPTION_IMG_MODEL,
  /**
   *  배송 정보
   */
  proDeliveryInfo: PRODUCT_DELIVERY_INFO_MODEL,
  /**
   *  A/S 정보
   */
  proAfterService: PRODUCT_AFTER_SERVICE_MODEL,
  /**
   * 외부 채널 전송 여부
   */
  sentExternalChannel: false,
};

/**
 *  상품 상세 모델
 */
export const PRODUCT_DETAIL_MODEL = {
  /**
   *  상품 ID
   */
  productId: null,
  /**
   *  상품 좋아요 개수
   */
  likeCount: 0,
  /**
   *  상품 로그 ID
   */
  productUpdateLogId: null,
  /**
   *  상품 상태 및 브랜드 정보
   */
  proStatusAndBrandInfo: PRODUCT_STATUS_AND_BRAND_INFO_MODEL,
  /**
   *  카테고리
   */
  proCategory: PRODUCT_CATEGORY_MODEL,
  /**
   *  상품명, 가격, 할인정보
   */
  proNameAndPrice: PRODUCT_NAME_AND_PRICE_MODEL,
  /**
   *  재고/옵션
   */
  proStockAndOption: PRODUCT_STOCK_AND_OPTION_MODEL,
  /**
   *  상품 공지사항
   */
  proNoticeProduct: {
    list: [],
  },
  /**
   *  상품 정보
   */
  proInfo: PRODUCT_INFO_MODEL,
  /**
   *  상품 이미지
   */
  proImg: PRODUCT_IMG_MODEL,
  /**
   *  상품 상세 설명
   */
  proDescriptionImg: PRODUCT_DESCRIPTION_IMG_MODEL,
  /**
   *  배송 정보
   */
  proDeliveryInfo: PRODUCT_DELIVERY_INFO_MODEL,
  /**
   *  A/S 정보
   */
  proAfterService: PRODUCT_AFTER_SERVICE_MODEL,
  /**
   * 외부 채널 전송 정보
   */
  productExternalInfo: [],
};

/**
 * 상품 상세 초기 데이터 모델
 */
export const INIT_PRODUCT_DETAIL_MODEL = {
  productDetail: PRODUCT_DETAIL_MODEL,
  storeSelectList: [],
  mainProductCategorySelectList: {
    normal: [],
    emphasis: [],
  },
  subProductCategorySelectList: {},
  minimumPrice2000WonCategoryIdList: [],
  productPayMethodTypeInfo: {},
  productPropertyList: PRODUCT_PROPERTY_MODEL,
  productTagInfo: {
    conceptTag: [],
    seasonSituationTag: [],
  },
};

/**
 *  상품 옵션 아이템 모델
 */
export const PRODUCT_OPTION_ITEM_MODEL = {
  /**
   *  이미지 식별 ID
   */
  id: null,
  /**
   *  옵션 값
   */
  name: null,
  /**
   *  옵션 노출 순서
   */
  no: null,
  /**
   *  옵션 가격
   */
  price: 0,
  /**
   *  옵션 재고
   */
  stockCount: null,
  /**
   *  옵션 상태 (0: 비 노출, 1: 노출, 2: 품절)
   */
  status: PRODUCT_OPTION_STATUS.ACTIVE,
  /**
   *  스타일 코드
   */
  styleCode: null,
  /**
   *  옵션 번호
   */
  number: null,
  /**
   *  상품관리타입 SELECT LIST
   */
  productManagementTypeSelectList: AMONDZ_PRODUCT_MANAGEMENT_TYPE_SELECT_LIST,
  /**
   *  상품 관리 타입
   */
  productManagementType: PRODUCT_MANAGEMENT_TYPE.ENTER,
  /**
   *  선물 여부
   */
  isGift: true,
  /**
   *  수수료 정보 토글
   */
  isShowFeeInfo: true,
  /**
   *  수수료 정보
   */
  feeInfo: {
    /**
     *  PG 수수료 여부
     */
    isPgFee: true,
    /**
     *  아몬즈수수료
     */
    amondzFeeRate: 14,
    /**
     *  마케팅수수료
     */
    marketingFeeRate: 10,
    /**
     *  풀필먼트수수료
     */
    fulfillmentFeeRate: 0,
  },
};

/**
 *  상품 엑셀 일괄 편집 데이터 모델
 */
export const PRODUCT_BULK_EDIT_DATA_MODEL = {
  file: null,
  bulkEditProductValidResultList: [],
  bulkEditProductValidResultCount: {
    total: 0,
    success: 0,
    failed: 0,
  },
};

/**
 *  상품 버전 모델
 */
export const PRODUCT_VERSION_MODEL = {
  /**
   *  현재 버전
   */
  currentVersionDetail: PRODUCT_VERSION_DETAIL_MODEL,

  /**
   *  비교할 대상 버전
   */
  targetVersionDetail: PRODUCT_VERSION_DETAIL_MODEL,

  /**
   *  비교할 대상 버전의 id
   */
  targetVersionDetailId: null,

  /**
   *  현재 버전 정보
   */
  currentVersionInfo: setProductVersionInfo(),

  /**
   *  상품 버전 리스트
   */
  productVersionList: [],

  /**
   * 상품 속성 리스트
   */
  productPropertyList: PRODUCT_PROPERTY_MODEL,

  /**
   *  비교할 대상 버전의 거절 사유
   */
  rejectReason: {
    /**
     *  거절 타입
     */
    type: null,
    /**
     *  거절 사유
     */
    reason: null,
  },
};
